import React from "react";
import { useMediaQuery } from "react-responsive";
import SectionHeading from "./sectionHeading";
import DropdownOverlap from "./dropdownOverlap";
import { LazyLoadImage } from "react-lazy-load-image-component";

const MobileAppDropdown = ({ content }) => {
  const { title, subtitle, linkUrl, linkText, image, list } = content;
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });
  const showButton = linkText?.length ? true : false;

  return (
    <div id="mobileAppDropdown">
      <div className="main">
        <div className="left">
          <SectionHeading
            title={isMobile ? content.titleMobile || title : title}
            subtitle={subtitle}
            className="sectionHeading"
          />
          <DropdownOverlap content={list} />
          {showButton && (
            <div className="button">
              <a href={linkUrl} className="linkSecondary sm">
                <span>{linkText}</span>
              </a>
            </div>
          )}
        </div>
        {!isMobile && (
          <div className="right">
            <LazyLoadImage src={image?.url} alt={image?.alternativeText || ""} effect="blur" />
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileAppDropdown;
